import { TextInputField } from 'components/Form/TextInputField'
import { Input } from 'almanac-ui/TextInputField/Input'
import { BlogMetadataFormState, BlogMetadataFormHandlers } from '../../../hooks/useBlogMetadataFormState'
import Styles from '../../../BlogMetadata.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface BlogMetadataFormFieldsProps {
  formState: BlogMetadataFormState
  handlers: BlogMetadataFormHandlers
  shouldShowAuthorField?: boolean
}

export const BlogMetadataFormFields: React.FC<BlogMetadataFormFieldsProps> = ({
  formState,
  handlers,
  shouldShowAuthorField = true,
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { title, author, summary, slug } = formState
  const { handleTitleChange, handleAuthorChange, handleSummaryChange, handleSlugChange } = handlers

  return (
    <>
      <TextInputField
        wrapperClassName={Styles.inputField}
        label="Title"
        value={title}
        onChange={handleTitleChange}
        size={isSystemRedesignEnabled ? 'md' : 'lg'}
        labelClassName={Styles.textFieldLabel}
      />
      {shouldShowAuthorField && (
        <TextInputField
          wrapperClassName={Styles.inputField}
          label="Author"
          value={author}
          onChange={handleAuthorChange}
          size={isSystemRedesignEnabled ? 'md' : 'lg'}
          labelClassName={Styles.textFieldLabel}
        />
      )}

      <div>
        <label className={Styles.textFieldLabel}>Summary</label>
        <div className={Styles.summaryInput}>
          <Input
            name="summary"
            placeholder="Enter a summary for your blog post"
            value={summary || ''}
            onChange={handleSummaryChange}
            size="md"
            isTextarea={true}
            rows={4}
          />
        </div>
      </div>

      <TextInputField
        wrapperClassName={Styles.inputField}
        label="URL Slug"
        value={slug}
        onChange={handleSlugChange}
        size={isSystemRedesignEnabled ? 'md' : 'lg'}
        labelClassName={Styles.textFieldLabel}
      />
    </>
  )
}
